module.exports = __webpack_public_path__ + "img/ic-menu-close-white.51b2484d.svg";